import { useEffect, useState } from 'react';

import { useApi } from '@backstage/core-plugin-api';

import { kaapApiRef } from '../api/KaapApiClient';
import { Application } from '../types';

/**
 * Loads the KaaP applications catalog (id → name / cost-center / org-unit /
 * business-unit). Only fetched when `enabled`, since it requires a call to the
 * KaaP API and is used solely by the admin-only filters.
 */
export const useApplications = (enabled: boolean): Application[] => {
  const kaapApi = useApi(kaapApiRef);
  const [applications, setApplications] = useState<Application[]>([]);

  useEffect(() => {
    if (!enabled) {
      setApplications([]);
      return undefined;
    }

    let cancelled = false;
    kaapApi
      .getApplications()
      .then(apps => {
        if (!cancelled) {
          setApplications(apps);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setApplications([]);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [kaapApi, enabled]);

  return applications;
};
